import './CheckList.scss';
import { prefixClass } from 'lib/utils';
import { IconValidateNew, IconMenu } from 'components/Icons';
import classNames from 'classnames';

const CheckListButton = ({ status, onClick }: { status: boolean; onClick?: () => void }) => {
  const prefix = prefixClass('q2-check-list-button');
  const handleClick = () => {
    onClick?.();
  };

  return (
    <button
      type="button"
      className={classNames(prefix(), { completed: status })}
      onClick={handleClick}
      aria-pressed={status}
    >
      {status && (
        <div className={prefix('icon')}>
          <IconValidateNew />
        </div>
      )}
    </button>
  );
};

export interface CheckListItemProps {
  id: string;
  order?: number;
  label: string;
  completed: boolean;
  createdAt?: string;
  completedAt?: string;
  completedBy?: string;
  upload?: boolean;
  uploadUrl?: string;
}

const CheckListItem = ({
  item,
  onToggle,
  editable,
}: {
  item: CheckListItemProps;
  onToggle?: (id: string, value: boolean) => void;
  editable?: boolean;
}) => {
  const prefix = prefixClass('q2-check-list-item');
  const handleToggle = () => {
    const nextValue = !item.completed;
    onToggle?.(item.id, nextValue);
  };

  return (
    <div className={classNames(prefix(), { editable })}>
      <div className={prefix('selection')}>
        <div className={prefix('selection-drag')}>
          <IconMenu />
        </div>
        <CheckListButton status={item.completed} onClick={handleToggle} />
      </div>

      <div
        className={classNames(prefix('label'), { completed: item.completed })}
        onClick={!editable ? handleToggle : undefined}
      >
        {item.label}
      </div>
    </div>
  );
};

export interface CheckListProps {
  items: CheckListItemProps[];
  onChange?: (items: CheckListItemProps[]) => void;
  editable?: boolean;
}

const CheckList = ({ items, onChange, editable }: CheckListProps) => {
  const prefix = prefixClass('q2-check-list');

  const handleToggle = (id: string, value: boolean) => {
    if (!onChange) {
      return;
    }
    const updated = items.map(item =>
      item.id === id
        ? {
            ...item,
            completed: value,
            completedAt: value ? new Date().toISOString() : undefined,
            completedBy: value ? 'John Doe' : undefined,
          }
        : item
    );
    onChange(updated);
    //console.log(updated);
  };

  return (
    <div className={prefix()}>
      {items.map(item => (
        <CheckListItem key={item.id} item={item} onToggle={handleToggle} editable={editable} />
      ))}
    </div>
  );
};

export default CheckList;
